import React, {Component} from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJClose from "../view/FJClose.icon";
import classNames from 'classnames';
import Style from './FJExportHeader.module.less';
import PropTypes from 'prop-types';

class FJExportHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tagWidth: 60,
      tagLeft: 32,
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.tagIndex !== this.props.tagIndex) {
      this.updateInfo();
    }
  }

  updateInfo = () => {
    try {
      const {list, tagIndex} = this.props;
      const __curType =list[tagIndex].type;
      const {width, left} = this[__curType].getBoundingClientRect();
      this.setState({
        tagWidth: width,
        tagLeft: left,
      })
    } catch (e) {
      console.log(e);
    }
  };

  _renderList = () => {
    const {list, tagIndex} = this.props;
    const {onTagChange} = this.props;
    return list.map((item, index) => {
      const {type, text} = item;
      return (
          <div className={classNames(Style.item, tagIndex === index ? Style.active : '')}
               key={type}
               ref={ele => this[type] = ele}
               onClick={() => {onTagChange(index)}}
          >
            {text}
          </div>
      );
    })
  };

  render() {
    const {tagWidth, tagLeft} = this.state;
    const {isShow} = this.props;
    const {onClose} = this.props;
    return (
        <div className={classNames(Style.box, isShow ? Style.active : '')}>
          <div className={Style.type_box}>
            {this._renderList()}
            <div className={Style.line} style={{width: tagWidth + 'px', left: tagLeft}}/>
          </div>
          <div className={Style.title}>{FJLocalStore._('export-video')}</div>
          <div className={Style.close} onClick={onClose}>
            <FJClose/>
          </div>
        </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement
FJExportHeader.propTypes = {
  isShow: PropTypes.bool,
  parentShown: PropTypes.bool,
  tagIndex: PropTypes.number,
  list: PropTypes.array,
  onTagChange: PropTypes.func,
  onClose: PropTypes.func,
};

// eslint-disable-next-line react/static-property-placement
FJExportHeader.defaultProps = {
  isShow: true,
  tagIndex: 0,
  list: [],
  onTagChange: () => {},
  onClose: () => {},
}

export default FJExportHeader
